import { propStore } from '../util';

export default function toggleDisplayLinksToState(settings, disabled): void {
    const displayLinkQuery = `*[class^=${settings.classNames.displayLink}] a`;
    const displayLinks = Array.from(document.querySelectorAll(displayLinkQuery));

    displayLinks.forEach(link => {
        if (disabled) {
            link.className = settings.classNames.displayLinkDisabled;
            propStore.backup(link);
        }
        else {
            link.className = '';
            propStore.restore(link);
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/element-disabler/src/disablers/displayLink.ts